var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":""}},[_c('editor',{ref:"editor",attrs:{"api-key":_vm.apiKey,"init":_vm.init},on:{"onChange":_vm.emitInput,"onKeyDown":_vm.emitInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }